interface UpdateState {
  externalId: number;
  updated: boolean;
}

export enum SubmitType {
  save,
  submit,
}
